import Http from "./Http";

/**
 * TPX-2071: Otelier-only internal settings per HMG (Settings → Internal settings tab).
 * Used by the Settings page and the help button (SupportFAB).
 */

/** GET /internal-settings/{hmgId} → { trudyEnabled, feedbackDestination } (defaults applied by the backend). */
export const getInternalSettings = async (hmgId) => {
  const response = await Http.GET(`internal-settings/${hmgId}`);
  return response?.data ?? null;
};

/**
 * PUT /internal-settings/{hmgId} — partial update, Otelier users only.
 * Send only the changed fields, e.g. { trudyEnabled: true } or { feedbackDestination: "SUPPORT" }.
 */
export const saveInternalSettings = async (hmgId, changes) => {
  return Http.PUT(`internal-settings/${hmgId}`, changes);
};
